import request from '../utils/request'

export function selectItemsList(data) {
  return request({
    url: '/api/item/list',
    method: 'post',
    data,
  })
}
export function fetchItems(data) {
  return request({
    url: '/api/item/fetch',
    method: 'post',
    data,
  })
}
